import { render, staticRenderFns } from "./post.vue?vue&type=template&id=311daa68&scoped=true&"
import script from "./post.vue?vue&type=script&lang=js&"
export * from "./post.vue?vue&type=script&lang=js&"
import style0 from "./post.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./post.vue?vue&type=style&index=1&id=311daa68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311daa68",
  null
  
)

export default component.exports